export const DECK_URLS = [
  "https://www.realmsapp.com/sorcery_tcg/decklists/250/exports/TTS/share.json",
  "https://www.realmsapp.com/sorcery_tcg/decklists/236/exports/TTS/share.json",
  "https://curiosa.io/decks/cm0q6mlp80085np863aq5ssv7",
  "https://curiosa.io/decks/cm0q4yuvu00czvobolg13go90",
  "https://curiosa.io/decks/clrnwnocl004d1tg5xm4vngy8",
  "https://curiosa.io/decks/clqfoggp300dp12y9jimkal6a",
];
